// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".client-list[data-v-4433ebeb]{display:grid}li[data-v-4433ebeb]{list-style:none;width:100%}li label[data-v-4433ebeb]{display:grid;grid-template-columns:6fr 2fr}\n", ""]);
// Exports
module.exports = exports;
